import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useManageTable } from "hooks";
import { GetListRequestParams } from "libs/api";

import { useGetInventoryQrsList } from "../apis";

const useQrsList = () => {
  const {
    page,
    searchValue,
    debouncedSearch,
    sorting,
    setSorting,
    setSearchValue,
    setPage
  } = useManageTable();

  const requestParams: GetListRequestParams = {
    page,
    take: GET_LIST_REQUEST_DEFAULT_LIMIT,
    search: debouncedSearch,
    orderBy: sorting[0]?.id,
    order: sorting[0] ? (sorting[0]?.desc ? "DESC" : "ASC") : "DESC"
  };

  const {
    inventoryBoxesQrsList,
    meta,
    isLoading,
    refetch: refetchInventoryBoxesQrsList
  } = useGetInventoryQrsList(requestParams);

  return {
    inventoryBoxesQrsList,
    totalItems: meta?.itemCount ?? 0,
    searchValue,
    page,
    isLoading,
    sorting,
    setSorting,
    setSearchValue,
    setPage,
    refetchInventoryBoxesQrsList
  };
};

export default useQrsList;
